<template>
  <vs-popup
    class="credit-note-email-log-popup"
    title="CREDIT NOTE EMAIL LOGS"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>

      <vs-table :data="logs">
        <template slot="thead">
          <vs-th>Credit Note</vs-th>
          <vs-th>Customer</vs-th>
          <vs-th>Customer Email</vs-th>
          <vs-th>Sent By Staff</vs-th>
          <vs-th>Sent At</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            v-for="(item, index) in data"
            :key="item.id || index"
          >
            <vs-td>
              {{ item.credit_note.credit_note_code || "N/A" }}
            </vs-td>

            <vs-td>
              {{ item.customer_user.first_name }}
              {{ item.customer_user.last_name || "" }}
            </vs-td>

            <vs-td>
              {{ item.customer_user.email }}
            </vs-td>

            <vs-td>
              {{ item.created_by_staff.name || "N/A" }}
            </vs-td>

            <vs-td>
              {{ __dateTimeFormatter(item.created_at) }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";

const CustomerRepository = RepositoryFactory.get("customer");

export default {
  name: "CreditNoteEmailLogPopUp",

  data() {
    return {
      open: false,
      id: null,
      logs: [],
    };
  },

  methods: {
    async openPopup(id) {
      this.open = true;
      this.id = id;

      await this.getCreditNoteEmailLogs();
    },

    async getCreditNoteEmailLogs() {
      try {
        const response =
          await CustomerRepository.getCreditNoteEmailLogs(this.id);

        this.logs = response.data.data || [];
      } catch (error) {
        this.logs = [];
      }
    },
  },
};
</script>


<style scoped>
.credit-note-email-log-popup>>>.vs-popup {
  /*min-height: 80% !important;*/
  min-width: 60% !important;
}
</style>
